import * as React from 'react';
import testIds from './ClientActionList.elements';
import ClientActionListItem from './ClientActionListItem/ClientActionListItem';
import * as Styled from './styled';
const ClientLeadsIcon = require('./images/icon-client-leads.png');
const DocumentLibraryIcon = require('./images/icon-document-library.png');
const FormsBrochuresIcon = require('./images/icon-forms-brochures.png');

const ClientActionList: React.FunctionComponent = () => (
	<Styled.Nav>
		<Styled.Ul data-id={testIds.listOfActionLinks}>
			<ClientActionListItem
				id={testIds.clientLeadsLink}
				title="Fund performance"
				url="/secure/adviser/products/performance-pricing/performance"
				icon={ClientLeadsIcon}
			/>
			<ClientActionListItem
				id={testIds.documentLibraryLink}
				title="Document library"
				url="/work/documents"
				icon={DocumentLibraryIcon}
			/>
			<ClientActionListItem
				id={testIds.formAndBrochuresLink}
				title="Forms and brochures"
				url="/secure/adviser/resources/forms-brochures/most-popular"
				icon={FormsBrochuresIcon}
			/>
		</Styled.Ul>
	</Styled.Nav>
);

export default ClientActionList;
